import { useState, useEffect } from "react";

const useElementWidthObserver = (ref, threshold = 700) => {
   const [isSmall, setIsSmall] = useState(false);

   useEffect(() => {
      if (!ref.current) return;

      const observer = new ResizeObserver((entries) => {
         for (let entry of entries) {
            const width = entry.contentRect.width;
            console.log(`Measured Width: ${width}px (Threshold: ${threshold}px)`);
            // Ensure state updates only when needed
            setIsSmall((prev) => {
               if (prev !== (width < threshold ? true : false)) {
                  return width < threshold;
               }
               return prev; // Avoid unnecessary re-renders
            });
         }
      });

      observer.observe(ref.current);

      return () => {
         observer.disconnect();
      };
   }, [ref, threshold, ref.current]);

   return isSmall;
};

export default useElementWidthObserver;
